import React, { useEffect, useState } from "react";
import { Button, Grid } from "semantic-ui-react";
import MetaData from "../../components/MetaData";
import moment from "moment-timezone";
import { useWindowSize } from "../../utils/utils";

const CompanyRanking = (props) => {
  const [isLoading, setIsLoading] = useState(true);
  const [jsonData, setJsonData] = useState(null);
  const [companyData, setCompanyData] = useState(null);
  const [userEmails, setUserEmails] = useState([]);

  const [isMobile, setIsMobile] = useState(false);

  const size = useWindowSize();

  const apiUrl =
    "https://boahub-users.s3.ap-southeast-2.amazonaws.com/hoseAssemblyCompetition.json";

  useEffect(() => {
    if (size.width !== 0) {
      if (size.width <= 900) {
        setIsMobile(true);
      } else {
        setIsMobile(false);
      }
    }
  }, [size]);

  useEffect(() => {
    setIsLoading(true);
    fetch(apiUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        if (data) setJsonData(data);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("There was a problem with the fetch operation:", error);
        setIsLoading(false);
      });
  }, [apiUrl]);

  useEffect(() => {
    const companyId = Number(localStorage.getItem("companyId"));
    if (jsonData) {
      if (jsonData.data[companyId]) {
        setCompanyData(jsonData.data[companyId]);
        setUserEmails(jsonData.data[companyId]?.userEmails);
      }
    }
  }, [jsonData]);

  useEffect(() => {
    console.log(companyData);
  }, [companyData]);

  const superscriptStyle = {
    verticalAlign: "super",
    fontSize: "smaller",
  };

  const userEmailList = Object.entries(userEmails).map(([email, count]) => (
    <div style={{ marginTop: isMobile ? 5 : 0 }}>
      <span
        style={{
          fontSize: isMobile ? 20 : 26,
          fontWeight: "bold",
          color: "#66CB23",
          lineHeight: 1.5,
        }}
      >
        {count}
      </span>
      <span
        style={{
          fontSize: isMobile ? 20 : 26,
          fontWeight: "bold",
          lineHeight: 1.5,
        }}
      >
        {" "}
        -{" "}
      </span>
      <a
        style={{
          fontSize: isMobile ? 20 : 26,
          fontWeight: "bold",
          lineHeight: 1.5,
          textDecoration: "underline",
        }}
      >
        {email}
      </a>
      <br />
    </div>
  ));

  const formatDate = (utcTime) => {
    var newUTCString = utcTime.replace(/ /g, "T");
    newUTCString = newUTCString + "Z";

    const userTimeZone = moment.tz.guess();
    return moment(newUTCString).tz(userTimeZone).format("YYYY-MM-DD HH:mm:ss");
  };

  function getSuffix(rank) {
    if (rank % 10 === 1 && rank % 100 !== 11) {
      return "st";
    } else if (rank % 10 === 2 && rank % 100 !== 12) {
      return "nd";
    } else if (rank % 10 === 3 && rank % 100 !== 13) {
      return "rd";
    } else {
      return "th";
    }
  }

  return (
    <React.Fragment>
      <MetaData title="Company Ranking" />
      <Grid columns={1} className="company-ranking-container">
        {companyData ? (
          <Grid.Row className="company-ranking-main-section">
            <Grid.Column width={16} style={{ paddingLeft: 0, paddingRight: 0 }}>
              <Grid.Row>
                <Grid.Column
                  width={8}
                  style={{ paddingLeft: 0, paddingRight: 0 }}
                >
                  <div
                    style={{
                      marginTop: isMobile ? 10 : 30,
                      textAlign: "center",
                      fontSize: isMobile ? 28 : 40,
                      fontWeight: "bold",
                    }}
                  >
                    <span>{localStorage.getItem("companyName")}</span>
                  </div>
                </Grid.Column>
              </Grid.Row>
              <Grid
                columns={isMobile ? 1 : 2}
                style={{
                  marginTop: isMobile ? 10 : 20,
                  marginBottom: isMobile ? 25 : 50,
                }}
              >
                <Grid.Row>
                  <Grid.Column
                    width={isMobile ? 16 : 8}
                    style={{ paddingLeft: 0, paddingRight: 0 }}
                  >
                    <div
                      style={{
                        height: isMobile ? 300 : 500,
                        width: isMobile ? 300 : 500,
                        backgroundColor: "#66CB23",
                        borderRadius: 360,
                        textAlign: "center",
                        paddingTop: isMobile ? 60 : 75,
                        marginLeft: "auto",
                        marginRight: isMobile ? "auto" : 0,
                      }}
                    >
                      <div
                        style={{
                          textAlign: "center",
                          fontSize: isMobile ? 100 : 200,
                          color: "#fff",
                          fontWeight: "bolder",
                        }}
                      >
                        {companyData?.ranking}
                        <span style={superscriptStyle}>
                          {companyData?.ranking > 0
                            ? getSuffix(companyData?.ranking)
                            : ""}
                        </span>
                      </div>
                      <div
                        style={{
                          marginTop: isMobile ? 25 : 35,
                          textAlign: "center",
                          fontSize: isMobile ? 10 : 13,
                          color: "#fff",
                        }}
                      >
                        data updated at <br />
                        {formatDate(jsonData?.updated_datetime)}
                      </div>
                    </div>
                  </Grid.Column>
                  <Grid.Column
                    width={size.width > 900 ? 8 : size.width > 600 ? 10 : 16}
                    style={{
                      paddingLeft: isMobile ? 20 : 80,
                      marginLeft: "auto",
                      marginRight: "auto",
                    }}
                  >
                    <div style={{ paddingTop: isMobile ? 25 : 50 }}>
                      <span
                        style={{
                          fontSize: isMobile ? 22 : 26,
                          fontWeight: "bold",
                        }}
                      >
                        Total hose assemblies made
                      </span>
                      <br />
                      <span
                        style={{
                          fontSize: isMobile ? 44 : 52,
                          fontWeight: "bold",
                          color: "#66CB23",
                          lineHeight: 1,
                        }}
                      >
                        {companyData?.companyTotal}
                      </span>
                    </div>
                    <div style={{ marginTop: isMobile ? 20 : 30 }}>
                      <span
                        style={{
                          fontSize: isMobile ? 20 : 26,
                          fontWeight: "bold",
                          lineHeight: isMobile ? 1 : 2,
                        }}
                      >
                        Most hose assemblies made in your company​
                      </span>
                      <br />
                      {userEmailList}
                    </div>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Grid.Column>
          </Grid.Row>
        ) : isLoading && companyData === null ? null : (
          <Grid.Row className="company-ranking-main-section">
            <Grid.Column width={16} style={{ paddingLeft: 0, paddingRight: 0 }}>
              <Grid.Row>
                <Grid.Column
                  width={8}
                  style={{ paddingLeft: 0, paddingRight: 0 }}
                >
                  <div
                    style={{
                      marginTop: 30,
                      textAlign: "center",
                      height: "120px",
                      width: "100%",
                      minWidth: "250px",
                      position: "relative",
                      marginBottom: 45,
                    }}
                  >
                    {localStorage.getItem("relatedCompanyLogoUrl") &&
                      localStorage.getItem("relatedCompanyLogoUrl") !==
                        "null" && (
                        <img
                          src={localStorage.getItem("relatedCompanyLogoUrl")}
                          className="logoImage2"
                          style={{
                            height: "100%",
                            width: "auto",
                            marginLeft: "auto",
                            marginRight: "auto",
                          }}
                        />
                      )}
                  </div>
                  <div
                    style={{
                      marginTop: 45,
                      textAlign: "center",
                      fontSize: 40,
                      fontWeight: "bold",
                    }}
                  >
                    <span>No hose assemblies found.</span>
                  </div>
                  <div
                    style={{
                      textAlign: "center",
                      marginTop: 30,
                      marginBottom: 10,
                    }}
                  >
                    <Button
                      size="small"
                      style={{
                        backgroundColor: "rgb(102, 204, 35)",
                        color: "#fff",
                      }}
                      onClick={() => props.history.push("/jobbing")}
                    >
                      Start making your hose assemblies in Jobbing!
                    </Button>
                  </div>
                </Grid.Column>
              </Grid.Row>
            </Grid.Column>
          </Grid.Row>
        )}
      </Grid>
    </React.Fragment>
  );
};

export default CompanyRanking;
